import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import Layout from '../components/app';
import Default from '../components/pages/products/default';
//import ExtendedInfo from '../components/pages/products/extended-info';

// Google analytics
import ReactGA from 'react-ga4';

export default function ProductsRoute() {
    const TRACKING_ID1 = "G-EVEGJY208D"; //groovooapp.com
    const TRACKING_ID2 = "G-24E964114T"; //groovoo.io
    const TRACKING_ID3 = "G-5JSSTEW6PJ"; //groovoo.app
    const TRACKING_ID4 = "G-Y11SC5R86J"; //groovoo.com
    ReactGA.initialize([
        { trackingId: TRACKING_ID1 },
        { trackingId: TRACKING_ID2 },
        { trackingId: TRACKING_ID3 },
        { trackingId: TRACKING_ID4 },
    ]);


    useEffect(() => {
        // TrackGoogleAnalyticsEvent("Pageview", "Products", "Products");
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search});
        console.log("GA: ", window.location.pathname);
        console.log("GA: ", window.location.search);
    }, []);
      
    return (
        <Switch>
            <Layout>
                <Route exact path={ `${process.env.PUBLIC_URL}/e/:alias` } component={ Default } />
                <Route exact path={ `${process.env.PUBLIC_URL}/event/:id` } component={ Default } />
            </Layout>
        </Switch>
    );
}
